module.exports = __webpack_public_path__ + "static/img/lv5.700183c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/other/lv5.png
// module id = eQmk
// module chunks = 1